import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'structureformats',
  templateUrl: './structureformats.component.html',
  styleUrls: ['./structureformats.component.scss']
})
export class StructureformatsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
